/**
 * ROC 7
 * Copyright 2017 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */

define('modules/Upcharges/Impl/TextEngravingUpcharge',[
    'jquery',
    'lodash',
    'global/all',
    'modules/Upcharges/UpchargeRegistrationService'
], function ($, _, Roc, UpchargeRegistrationService) {
    'use strict';

    var upchargeCode = 'TEXTENGRAVING';

    var selectors = {
        checkboxSelector: 'input[data-roc-field="isEngraved"]',
        engravingDetailsForm: '[data-roc-wrapper="engraving-details-form"]',
        engravingForm: '[data-roc-wrapper="engraving-form"]',
        engravingTextField: '[data-roc-field="engravingText"]'
    }

    function preRenderQuickView(viewModel) { 
        var engravingConfiguration = {
            isEngravingEnable: false,
            engravingTextMaxLength: 50,
            engravingUpchargeFee: 0.2,
            showEngravingForm: false
        };

        var upchargesSettings = window.RocConfig.upcharges.configuration;
        var engrConfiguration = _.find(upchargesSettings, function (upchargeSettings) {
            return upchargeSettings.upchargeCode == upchargeCode;
        });

        if (engrConfiguration && engrConfiguration.configuration["isEngravingEnable"]) {
            engravingConfiguration.isEngravingEnable = engrConfiguration.configuration["isEngravingEnable"];
        }

        if (engrConfiguration && engrConfiguration.configuration["engravingUpchargeFee"]) {
            engravingConfiguration.engravingUpchargeFee = engrConfiguration.configuration["engravingUpchargeFee"];
        }

        if (engrConfiguration && engrConfiguration.configuration["engravingTextMaximumLength"]) {
            engravingConfiguration.engravingTextMaxLength = engrConfiguration.configuration["engravingTextMaximumLength"];
        }

        var isEngravable = false;
        var isEngravableAttrs = viewModel.product.customFields["isEngravable"];
        
        if (viewModel.product.productType === 'Simple' && isEngravableAttrs && _.some(isEngravableAttrs)) {
            isEngravable = _.some(isEngravableAttrs, function (attr) { return attr.value; })
        }
        engravingConfiguration.showEngravingForm = engrConfiguration && isEngravable && viewModel.product.canAddProduct && viewModel.product.productType !== 'Group';
        viewModel.engravingConfiguration = engravingConfiguration;
        
    }

    function bindEvents() {
        $(document)
            .off('change', selectors.checkboxSelector)
            .on('change', selectors.checkboxSelector, onTextEngravingChanged);
        countCharactersLeft();
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadProductEngraving);
    }

    function reloadProductEngraving(viewModel) {        
        var isEngravable = false;
        var isEngravableAttrs = viewModel.customFields["isEngravable"];        

        if (viewModel.productType === 'Simple' && isEngravableAttrs && _.some(isEngravableAttrs)) {
            isEngravable = _.some(isEngravableAttrs, function (attr) { return attr.value; })
        }

        // reset engraving form
        $(selectors.engravingForm).toggle(isEngravable);
        $(selectors.engravingDetailsForm).hide();
        $(selectors.engravingTextField).val('')
        $(selectors.checkboxSelector).prop('checked', false);
    }

    function populateUpchargeData(upchargeData) {
        var isEngravedInput = $(selectors.checkboxSelector + ':checked');

        if (isEngravedInput.length > 0) {
            upchargeData[upchargeCode] = {
                'code': upchargeCode,
                'json': {
                    'text': $(selectors.engravingTextField).val()
                }
            };
        }
    }

    function countCharactersLeft() {
        $(document).on('keyup', '[data-roc-field="engravingText"]', function () {

            var charsLeft = Roc.UI.countCharactersLeft('[data-roc-field="engravingText"]');
            if (charsLeft !== null) {
                var engravingTextContainer = $(this).parent(selectors.engravingDetailsForm);
                Roc.UI.template('engravingRemainingText-Tmp', { remainingText: charsLeft }).then(function (renderedTemplate) {
                    engravingTextContainer.find('.engravingText.remaining').html(renderedTemplate);
                });
            }
        });
    }

    function onTextEngravingChanged() {
        var isChecked = $(this).is(':checked');

        // hide or display the engraving text form if we've checked the engraving checkbox
        $(selectors.engravingDetailsForm).toggle(isChecked);
    }

    var TextEngravingUpcharge = {
        bindEvents: bindEvents,
        preRenderQuickView: preRenderQuickView,
        populateUpchargeData: populateUpchargeData
    };

    Roc.Logger.debug('TextEngravingUpcharge.js Loaded:', TextEngravingUpcharge);

    // register upcharge
    UpchargeRegistrationService.register(upchargeCode, TextEngravingUpcharge);

    return TextEngravingUpcharge;
});

